import React from 'react';
import { connect } from 'redux-bundler-react';
import { markdown } from 'markdown';
import xhr from 'xhr';

class DatasetInfo extends React.Component {
  constructor(props){
    super(props);
    this.state = {
      __html: '<p>Loading</p>'
    }
    this.close = this.close.bind(this);
    this.renderAsync = this.renderAsync.bind(this);
    this.renderContent = this.renderContent.bind(this);
    this.renderMarkdown = this.renderMarkdown.bind(this);
  }

  componentDidMount(){
    const { item } = this.props;
    if(item.info){
      if(item.info.url) return this.renderAsync();
      if(item.info.content) return this.renderContent();
    }
  }

  close() {
    const { doCloseModalWindow } = this.props;
    doCloseModalWindow();
  }

  renderMarkdown(content){
    this.setState({
      __html: markdown.toHTML(content, 'Maruku')
    })
  }

  renderContent(){
    const { item } = this.props;
    const { content } = item.info;
    return this.renderMarkdown(content);
  }

  renderAsync(){
    const { item } = this.props;
    const { url } = item.info;
    xhr.get(url, (err, response, body) => {
      if(err){
        this.renderMarkdown('Error Loading Content');
      }else{
        this.renderMarkdown(body);
      }
    })
  }

  render(){
    const { theme, item } = this.props;
    return (
      <div>
        <div className={"modal-header " + theme}>
          { item.displayName } Metadata
        </div>
        <div
          className="modal-body thin-scrollbar"
          style={{ height: (window.innerHeight * 0.75), top: 0, bottom: 0, left: 0, right: 0, overflow: 'auto'}}
          dangerouslySetInnerHTML={ this.state }
        >
        </div>
        <div className="modal-footer">
          <button className={"btn btn-theme " + theme} onClick={this.close}>
            Close
          </button>
        </div>
      </div>
    )
  }
}

export default connect(
  'selectTheme',
  'doCloseModalWindow',
  DatasetInfo
);